<div class="swag-paypal-merchant-information">
    <p class="swag-paypal-merchant-information__email">
        {{ merchantEmail }}
        <br>
        {{ merchantInformationStore.actual.merchantIntegrations.legal_name }}
    </p>

    {% block swag_paypal_method_merchant_information_sandbox %}
    <swag-paypal-setting
        v-tooltip.left="{
            message: tooltipSandbox,
            disabled: !sandboxToggleDisabled,
        }"
        path="SwagPayPal.settings.sandbox"
        class="swag-paypal-merchant-information__sandbox-toggle"
        :disabled="sandboxToggleDisabled"
        :bordered="false"
        @update:value="onSandboxToggle"
    />
    {% endblock %}

    <div class="swag-paypal-merchant-information__buttons">
        <slot />
    </div>
</div>
